<template>
  <div id="search-mode">
    <div class="left-top-nav">
      <div
        v-for="(item, index) in leftTopNav"
        :key="index"
        :class="activeTab === item.name ? activeTabClass : '' "
        class="left-top-nav-element"
      >
        <div @click="changeSearchModal(item.name)">
          {{ item.tab_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import leftTopNavItems from '../../config/enum/searchMode';

export default {
  name: 'SearchMode',
  data() {
    return {
      activeTabClass: "active-tab",
    };
  },
  computed: {
    ...mapState('main', [
      'activeTab'
    ]),
    leftTopNav() {
      return Object
        .keys(leftTopNavItems)
        .map(x => leftTopNavItems[x]);
    },
  },
  methods: {
    ...mapMutations('main', [
      'setSearchMode',
    ]),
    changeSearchModal(mode) {
      this.$router.push({
        name: leftTopNavItems[mode].mode,
      });

      this.setSearchMode(leftTopNavItems[mode]);
    },
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>
